import { quickCategories } from "@/mocks/home";

export default function QuickCategories() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-6">
          <h2 className="font-heading text-xl md:text-2xl font-semibold tracking-wide uppercase text-foreground-950">
            分类快捷入口
          </h2>
          <p className="text-xs md:text-sm text-foreground-500 mt-1">按内容类型快速浏览你感兴趣的作品</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {quickCategories.map((cat) => (
            <a
              key={cat.id}
              href={`/category/${cat.id}`}
              className="group relative block h-56 md:h-64 overflow-hidden rounded-lg ring-1 ring-background-200/70 cursor-pointer"
            >
              <img
                src={cat.cover}
                alt={`${cat.title}封面`}
                title={`${cat.title} - 天堂电影网`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/70 to-transparent" />
              <div className="relative h-full p-6 md:p-8 flex flex-col justify-center max-w-sm">
                <span className="inline-flex w-fit items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  <i className="ri-folders-line" aria-hidden="true" />
                  共 {cat.count} 部
                </span>
                <h3 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">{cat.title}</h3>
                <p className="mt-1 text-sm text-accent-300">{cat.subtitle}</p>
                <p className="mt-2 text-xs md:text-sm text-foreground-400 leading-relaxed">{cat.description}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm text-foreground-800 group-hover:text-accent-300 transition-colors">
                  立即进入
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}